import LiveMap from "data/util/LiveMap";
import StereotypesStore from "data/StereotypesStore";
import { getTopLevelRecords } from "data/selectors/superRecords";
import TableStore from "data/TableStore";
import SuperRecordStore from "data/SuperRecordStore";
import ClientId from "data/ClientId";
import { getChildren } from "data/selectors/records";
import entityMetaStore from "data/meta/entityMetaStore";

class LockBuilder {

    constructor(tableAccess, key, id) {
        this.access = tableAccess;
        this.entityToWritable = new LiveMap(ek => {
            const info = entityMetaStore.getInfo(ek);
            return info.canWrite || info.canDelete;
        });
        this.locks = new Map(); // Map<table, Map<id, {id, _ts}>>

        this._lockEntityRecord = this._lockEntityRecord.bind(this);

        if (key.indexOf("/") > 0) {
            this.lockEntityRecord(key, id);
        } else {
            this.lockStereoRecord(key, id);
        }
    }

    _isEntityWritable(entityKey) {
        return this.entityToWritable.get(entityKey);
    }

    _lockEntityRecord(ep) {
        if (!this._isEntityWritable(ep.entityKey)) {
            return;
        }
        if (ClientId.is(ep.id)) {
            return;
        }
        const tk = ep.entityInfo.tableKey;
        if (!this.locks.has(tk)) {
            this.locks.set(tk, new Map());
        }
        const id = ep.id;
        this.locks.get(tk).set(id, {id, _ts: ep.getRecordMeta().ts});
        getChildren(ep).forEach(this._lockEntityRecord);
    }

    lockEntityRecord(key, id) {
        if (!this._isEntityWritable(key)) {
            return;
        }
        this._lockEntityRecord(this.access.getEntityProxy(key, id));
    }

    lockStereoRecord(key, id) {
        const si = StereotypesStore.getStereotypeByKey(key);
        si.implementations
            // the record exists (not a multi-table global)
            .filter(it => this.access.hasEntityRecord(it.key, id))
            // can write to the impl
            .filter(it => this._isEntityWritable(it.key))
            // lock it!
            .forEach(it => this.lockEntityRecord(it.key, id));
        if (si.magicRoot) {
            getTopLevelRecords(TableStore, SuperRecordStore.getRecord(
                key,
                id,
            )).forEach(this._lockEntityRecord);
        }
    }

    isEmpty() {
        return this.locks.size === 0;
    }

    toLockSet() {
        const locks = {};
        this.locks.forEach((ls, tn) =>
            locks[tn] = Array.from(ls.values()));
        return {
            id: ClientId.next(),
            locks
        };
    }

}

export default LockBuilder;



// WEBPACK FOOTER //
// ./app/data/LockBuilder.js